import styled from '@emotion/styled';

import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import COLORS, { COLORS_TEXT } from '@zola/zola-ui/src/styles/emotion/colors';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

const CONTAINER_PADDING = 40; // Corresponds to SPACING.LG
const CONTAINER_PADDING_MOBILE = 20; // Corresponds to SPACING.MD
const GRID_ITEM_PADDING = 7;
const GRID_ITEM_SIZE = 40;

const getGridWidth = (nbItems: number) => {
  const paddingBetweenItems = GRID_ITEM_PADDING * 2 * (nbItems - 1); // Only calculate the padding BETWEEN the items
  return GRID_ITEM_SIZE * nbItems + paddingBetweenItems;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${CONTAINER_PADDING}px;

  max-width: ${getGridWidth(9) + CONTAINER_PADDING * 2}px;

  // As soon as 9 colors no longer fit in a row, adjust for 6
  @media (max-width: 586px) {
    max-width: ${getGridWidth(6) + CONTAINER_PADDING_MOBILE * 2}px;
    padding: ${CONTAINER_PADDING_MOBILE}px;
  }
`;

export const Title = styled.div`
  color: ${COLORS_TEXT.PRIMARY};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_LARGE)}
`;

export const Subtitle = styled.div`
  color: ${COLORS_TEXT.BODY};
  margin-top: ${SPACING.SM};
  margin-bottom: ${SPACING.S32};
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)}

  ${MEDIA_QUERY.MOBILE} {
    margin-top: ${SPACING.XS};
    margin-bottom: ${SPACING.MD};
  }
`;

export const Grid = styled.div`
  align-self: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin: -${GRID_ITEM_PADDING}px;
`;

export const GridItem = styled.div`
  flex: 0 0 auto;
  padding: ${GRID_ITEM_PADDING}px;
  position: relative;
`;

type ColorProps = {
  value: string;
};
export const Color = styled.div<ColorProps>`
  background-color: #${props => props.value};
  border: 1px solid ${COLORS.ALTO};
  border-radius: 100%;
  height: ${GRID_ITEM_SIZE}px;
  position: relative;
  width: ${GRID_ITEM_SIZE}px;
`;
